module.exports = __webpack_public_path__ + "static/media/financial.598039aa.png";